module.exports = __webpack_public_path__ + "static/media/HCMM211.fe7a694a.jpg";